module.exports = __webpack_public_path__ + "static/img/03445217.3c2e49c0.png";